<template>
  <div class="home-container">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
   
    <!-- 头部背景 -->
    <div class="top_bg">
    </div>
    <div style="padding-top:83px;padding-bottom: 55px;margin: 0 auto;width:1200px;">
      <div style="display: flex;align-items: center;">
        <div>
          <div class="name">MEIFUZX</div>
          <div class="appiont">企业精神</div>
        </div>
        <div style="width: 694px;height: 1px;background: #D8E1E0"></div>
      </div>
      <div style="display: flex;align-items: center;margin-top: 55px;justify-content: space-between;width:1200px;">
        <div style="text-align: center;">
          <div class="top_img"><img src="../../static/img/culture/dev1.jpg" alt=""></div>
          <div class="top_index">专业</div>
        </div>
        <div style="text-align: center;">
          <div class="top_img"><img src="../../static/img/culture/dev2.jpg" alt=""></div>
          <div class="top_index">口碑</div>
        </div>
        <div style="text-align: center;">
          <div class="top_img"><img src="../../static/img/culture/dev3.jpg" alt=""></div>
          <div class="top_index">创新</div>
        </div>
        <div style="text-align: center;">
          <div class="top_img"><img src="../../static/img/culture/dev4.jpg" alt=""></div>
          <div class="top_index">诚信</div>
        </div>
        <div style="text-align: center;">
          <div class="top_img"><img src="../../static/img/culture/dev5.jpg" alt=""></div>
          <div class="top_index">专一</div>
        </div>
      </div>
    </div>
    <!-- 企业发展历程 -->
    <div style="background: #F9F9F9;width: 100%;padding-bottom: 82px;">
      <div style="padding-top: 78px;width: 1200px;margin: 0 auto;">
        <div style="display: flex;align-items: center;">
          <div>
            <div class="name">MEIFUZX</div>
            <div class="appiont">企业发展历程</div>
          </div>
          <div style="width: 694px;height: 1px;background: #D8E1E0"></div>
        </div>
      </div>
      <!-- 第一行 -->
      <div style="width:1200px;display: flex;padding-top: 112px;align-items: center;margin: 0 auto;">
        <div class="number_box">
          <div class="number_bg">
            <div class="number">1</div>
          </div>
          <div class="dep_img"><img src="../../static/img/culture/1.png" alt=""></div>
          <div class="dep_time">2013年12月23</div>
          <div class="dep_index" style="margin-top: 26px;">御韵项目启动</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">2</div>
          </div>
          <img src="../../static/img/culture/2.png" alt="" class="dep_img">
          <div class="dep_time">2015年10月01</div>
          <div class="dep_index" style="margin-top: 25px;">御韵软件正式上线</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">3</div>
          </div>
          <img src="../../static/img/culture/3.png" alt="" class="dep_img">
          <div class="dep_time">2016年06月03</div>
          <div class="dep_index" style="margin-top: 18px;">微信合伙人商城上线</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">4</div>
          </div>
          <img src="../../static/img/culture/4.png" alt="" class="dep_img">
          <div class="dep_time">2016年06月28</div>
          <div class="dep_index" style="margin-top: 21px;">合作客户遍布13个省份</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">5</div>
          </div>
          <img src="../../static/img/culture/5.png" alt="" class="dep_img">
          <div class="dep_time">2016年07月08</div>
          <div class="dep_index" style="margin-top: 8px;">通过中华人民共和国国家版权局登记注册</div>
        </div>
      </div>
      <!-- 第二行 -->
      <div style="width:1200px;margin: 0 auto;height: 150px;position: relative;">
        <div class="line_img3">
          <img src="../../static/img/culture/beto.png" alt="" style="width: 11px;height: 99px;margin: 25px 62px;">
        </div>
      </div>

      <div style="clear: both;"></div>
      <!-- 第三行 -->
      <div style="width: 1200px;display: flex;justify-content: space-between;align-items: center;margin: 0 auto;">
        <div class="number_box">
          <div class="number_bg">
            <div class="number">10</div>
          </div>
          <img src="../../static/img/culture/10.png" alt="" class="dep_img">
          <div class="dep_time">2018年07月26</div>
          <div class="dep_index" style="margin-top: 16px;">荣获“广东省厚德扶贫基金会”理事单位</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">9</div>
          </div>
          <img src="../../static/img/culture/9.png" alt="" class="dep_img">
          <div class="dep_time">2018年05月19</div>
          <div class="dep_index" style="margin-top: 7px;">港三板成功挂牌，股权代码：HK.10065</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">8</div>
          </div>
          <img src="../../static/img/culture/8.png" alt="" class="dep_img">
          <div class="dep_time">2018年03月30</div>
          <div class="dep_index" style="margin-top: 18px;">获得高新技术企业认定资格</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">7</div>
          </div>
          <img src="../../static/img/culture/7.png" alt="" class="dep_img">
          <div class="dep_time">2017年07月01</div>
          <div class="dep_index" style="margin-top: 19px;">全面升级御韵软件企业文化</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">6</div>
          </div>
          <img src="../../static/img/culture/6.png" alt="" class="dep_img">
          <div class="dep_time">2017年03月10</div>
          <div class="dep_index" style="margin-top: 16px;">3.5升级版系统全面上线</div>
        </div>
      </div>
      <!-- 第四行 -->
      <div style="width:1200px;margin: 0 auto;height: 150px;position: relative;">
        <div class="line_img2">
          <img src="../../static/img/culture/beto.png" alt="" style="width: 11px;height: 99px;margin: 25px 62px;">
        </div>
      </div>
      <div style="clear: both;"></div>
      <!-- 第五行 -->
      <div style="display: flex;width:1200px;align-items: center;margin: 0 auto;">
        <div class="number_box">
          <div class="number_bg">
            <div class="number">11</div>
          </div>
          <img src="../../static/img/culture/11.png" alt="" class="dep_img">
          <div class="dep_time">2019年05月20</div>
          <div class="dep_index" style="margin-top: 18px;">服务合作了近10000家美容院</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">12</div>
          </div>
          <img src="../../static/img/culture/12.png" alt="" class="dep_img">
          <div class="dep_time">2019年07月01</div>
          <div class="dep_index" style="margin-top: 19px;">美服在线(原“御韵软件”）品牌正式升级</div>
        </div>
        <div class="line_img">
          <img :src="line1" alt="" class="line1_img">
        </div>
        <div class="number_box">
          <div class="number_bg">
            <div class="number">13</div>
          </div>
          <img src="../../static/img/culture/13.png" alt="" class="dep_img">
          <div class="dep_time">2019年09月24</div>
          <div class="dep_index" style="margin-top: 4px;">美服在线与阿里巴巴本地生活年度战略合作计划签约，双方达成战略合作伙伴关系</div>
        </div>
      </div>
    </div>
    <!-- 服务宗旨 -->
    <div>
      <div style="padding-top: 92px;margin: 0 auto;padding-bottom:40px;width: 1200px;">
        <div style="display: flex;align-items: center;;">
          <div>
            <div class="name">MEIFUZX</div>
            <div class="appiont">服务宗旨</div>
          </div>
          <div style="width: 694px;height: 1px;background: #D8E1E0"></div>
        </div>
      </div>
      <div class="service_bg">
        <div style="width: 1073px;height: 195px;padding: 124px 64px;font-size: 22px;color: #1E1E1E;line-height: 39px;">
          <div style="text-indent:35px;">
            “以客户为中心，以服务为己任”只有一切从顾客出发，一切为顾客着想，扎实做好服务中每个细节，实施全过程优质服务，才能在激烈的竞争中赢得顾客的信赖。
          </div>
          <div style="text-indent:45px;margin-top: 50px">
            美服在线始终坚持“创新升级每一套系统，用心服务每一个顾客”的服务宗旨，真诚地为顾客提供高标准、超价值、最亲民的服务，提供落地的解决方案，深受顾客的认同和赞许。
          </div>
        </div>
      </div>
    </div>
    <div style="background: #F0F9FF;height: 287px;margin-top: 92px;margin-bottom: 50px;">
      <div
        style="width: 1200px;display: flex;align-items: center;padding-top: 66px;padding-bottom: 90px;margin: 0 auto;">
        <div>
          <div class="help">帮店家管好店·助厂商找到店</div>
          <div class="help_detail">
            <!-- 系统化地管理，有效帮助店家管理好自己的门店·合作店家超万家，助力厂家精准对接店家 -->
            美服在线，立足于美业、扎根于美业、服务于美业，致力于美业的发展与建设，使传统美业快速进入信息互联新美业时代。
          </div>
        </div>
        <div class="middle"></div>
        <div class="right_div">
          <div class="right_div_text">MEET</div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  export default {
    components: {RMTopDiv,RMBottomDiv},
    data() {
      return {
        line1: require("../../static/img/culture/beto1.png"),
        scroll100: true,
        scroll700: false,
        scroll: ''
      };
    },
    watch: {
      scroll: function () {      
        this.loadSroll();
      }
    },
    methods: {
      //首页
      goToHome() {
        this.$router.push("/");
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push("./home");
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push("./supplyChain");
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push("./marketingTools");
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push("./company");
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push("./channels");
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push("./contact");
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push("./culture");
      },
     //找美商学院-商学院文化
     goToCollege(){
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli(){
        this.$router.push("./Ali");
      },
       //找美商学院-行程安排
      gotoTravell(){
        this.$router.push('./Travell')
      },
       //找美商学院-讲师简介
      goToTeach(){},
       //找美商学院-相关案例
      goToCase(){},
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    created() { },

    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])
    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";

  .home-container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: scroll
  }

  .top_bg {
    background-image: url('../../static/img/culture/cu_banner.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 824px;
    position: relative;
    top: 0;
    left: 0;
  }

  .name {
    font-size: 36px;
    color: #343434;
    line-height: 54px;
    letter-spacing: 3px;
  }

  .appiont {
    font-size: 26px;
    color: #343434;
    line-height: 37px;
    letter-spacing: 2px;
    margin-top: 11px;
  }

  .top_img {
    width: 156px;
    height: 156px;
    margin: 0 auto;
  }

  .top_img img {
    width: 100%;
    height: 100%;
  }

  .top_index {
    font-size: 18px;
    color: rgba(72, 72, 72, 1);
    line-height: 25px;
    letter-spacing: 1px;
    margin-top: 17px;
  }

  .dep_img {
    width: 29px;
    height: 29px;
    margin-top: 14px;
    margin-left: 53px;
  }

  .dep_img img {
    width: 100%;
    height: 100%;
  }

  .dep_time {
    font-size: 12px;
    color: #282828;
    margin-top: 8px;
    text-align: center;
  }

  .dep_index {
    font-size: 12px;
    color: #282828;
    width: 120px;
    text-align: center;
    line-height: 20px;
    margin: 0 auto;
  }

  .number_box {
    background: white;
    width: 136px;
    height: 160px;
    position: relative;
  }
  /* .number_box:hover{
    color: #fff;
    background: #ED7829;
  }
  .number_box:hover .number_bg{
    background: #fff;
  }
  .number_box:hover .number{
    color: #ED7829;
  }
  .number_box:hover .dep_time{
    color: #fff;
  }
  .number_box:hover .dep_index{
    color: #fff;
  } */
  .number_bg {
    position: absolute;
    width: 36px;
    height: 36px;
    background: #ED7829;
    top: -18px;
    left: 9px;
  }

  .number {
    text-align: center;
    line-height: 20px;
    color: #fff;
    font-size: 14px;
    margin-top: 8px
  }

  .service_bg {
    background-image: url('../../static/img/culture/ic_service.png');
    background-position: center;
    background-repeat: no-repeat;
    width: 1200px;
    height: 443px;
    margin-top: 40px;
    margin-left: 18.75%;
    margin: 0 auto;
  }

  .help {
    font-size: 33px;
    color: #1B1B1B;
    line-height: 46px;
    letter-spacing: 3px;
  }

  .help_detail {
    font-size: 20px;
    color: #535353;
    letter-spacing: 1px;
    line-height: 48px;
    width: 663px;
  }

  .middle {
    width: 203px;
    height: 2px;
    background: #000000;
    margin-left: 240px;
  }

  .right_div {
    width: 93px;
    height: 44px;
    background: rgba(65, 66, 68, 1);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    margin-top: 42px;
    text-align: center;
  }

  .right_div_text {
    font-size: 26px;
    color: #fff;
    letter-spacing: 2px;
  }

  .line_img {
    width: 130px;
    height: 150px;
  }

  .line1_img {
    width: 99px;
    height: 11px;
    margin: 65px 18px
  }

  .line_img2 {
    width: 136px;
    height: 150px;
    position: absolute;
    left: 0;
  }

  .line_img3 {
    width: 136px;
    height: 150px;
    position: absolute;
    right: 0;
  }
</style>


// WEBPACK FOOTER //
// src/page/culture.vue